module.exports = __webpack_public_path__ + "img/environment-before.d834fcc4.jpg";